import { isValid, parse, format, isAfter } from "date-fns"

import { useTranslationsStore } from "@/stores/translations.js"

import * as quasarUtils from "@/services/quasarUtils.js"

const apiFormat = "yyyy-MM-dd"
const apiFormatRegex = new RegExp("^\\d\\d\\d\\d-\\d\\d-\\d\\d$")

const getDateFormatForLanguage = (lang) => {
  switch (lang) {
    case "fr":
      return "dd-MM-yyyy"
    default:
      return "yyyy-MM-dd"
  }
}

const getDateRegexForLanguage = (lang) => {
  switch (lang) {
    case "fr":
      return new RegExp("^\\d\\d-\\d\\d-\\d\\d\\d\\d$")
    default:
      return new RegExp("^\\d\\d\\d\\d-\\d\\d-\\d\\d$")
  }
}

const getDateFormatForCurrentLanguage = () => {
  const translationsStore = useTranslationsStore()
  return getDateFormatForLanguage(translationsStore.currentLanguage)
}

const getLocalizedStringFromDate = (value) => {
  if (!value) {
    return ""
  }

  try {
    const outputFormat = getDateFormatForCurrentLanguage()
    return format(new Date(value), outputFormat)
  } catch (err) {
    quasarUtils.handleError(err)
    return ""
  }
}

export const parseInCurrentFormat = (value) => parse(value, getDateFormatForCurrentLanguage(), new Date())

export const getApiStringFromDateString = (value) => {
  const date = parseInCurrentFormat(value)
  return getApiStringFromDate(date)
}

export const convertDateStringToUniversalMiliseconds = (dateString) => {
  const date = isDateStringValid(dateString, apiFormat) ? new Date(dateString) : undefined
  if (date) {
    return date.getTime()
  }
  return 0
}

export const isDateStringValid = (dateString, dateFormat) => {
  if (!dateString) {
    return false
  }

  const regex = dateFormat === apiFormat ? apiFormatRegex : getDateRegexForLanguage(useTranslationsStore().currentLanguage)
  if (!regex.test(dateString)) {
    return false
  }

  const parsed = parse(dateString, dateFormat || getDateFormatForCurrentLanguage(), new Date())

  return isValid(parsed)
}

export const getApiStringFromDate = (date) => {
  if (!date) {
    return ""
  }
  try {
    return format(date, apiFormat)
  } catch (err) {
    quasarUtils.handleError(err)
    return ""
  }
}

export const getTimeStringFromDate = (date) => {
  if (!date) {
    return ""
  }
  try {
    return format(date, "HH:mm")
  } catch (err) {
    quasarUtils.handleError(err)
    return ""
  }
}

export const getLocalizedStringFromDateTime = (value, skipTime = false) => {
  if (!value) {
    return ""
  }
  const splitted = value.split(" ")

  let date = null
  if (isDateStringValid(splitted[0], apiFormat)) {
    date = parse(splitted[0], apiFormat, new Date())
  }

  if (!date) {
    return ""
  }

  let ret = getLocalizedStringFromDate(date)

  if (splitted.length > 1 && !skipTime) {
    ret += " " + splitted[1]
  }
  return ret
}

export const isAfterOrEqual = (date1, date2) => isAfter(date1, date2) || date1.toISOString().split("T")[0] === date2.toISOString().split("T")[0]
